<template>
    <div class="container">
        <div @click="goback" style="font-size:14px;margin-bottom:10px;cursor: pointer;width:50px">
            <i class="el-icon-back"></i>
            返回
        </div>
        <div class="search">
            <div style="margin-bottom: 16px; float: right;">
                <el-button type="primary" size="small" @click="showAddDialog">新增规则</el-button>
            </div>
        </div>
        <!-- 列表 -->
        <el-table border v-bind:data="list">
            <el-table-column label="名称">
                <template v-slot="scope">
                    <span>{{ scope.row.rule_name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="区域">
                <template v-slot="scope">
                    <span>{{ scope.row.region }}</span>
                </template>
            </el-table-column>
            <el-table-column label="用户数量">
                <template v-slot="scope">
                    <span>{{ scope.row.user_count }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="300px">
                <template v-slot="scope">
                    <el-button type="danger" size="small" @click="delRule(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- <el-pagination @current-change="handleCurrentChange" v-model:currentPage="search.page" :page-size="search.limit"
            layout="total, prev, pager, next" :total="total">
        </el-pagination> -->

        <!-- 新增弹窗 -->
        <el-dialog v-model="dialogVisible" title="新增规则" width="500px" :close-on-click-modal="false">
            <el-form ref="formRef" :model="form" label-width="80px" :rules="rules">
                <el-form-item label="规则" prop="rule_code">
                    <el-select v-model="form.rule_code" placeholder="请选择规则" style="width: 100%">
                        <el-option v-for="item in ruleList" :key="item.code" :label="item.name" :value="item.code" />
                    </el-select>
                </el-form-item>
                <el-form-item label="区域" prop="region">
                    <el-select v-model="form.region" placeholder="请选择区域" style="width: 100%">
                        <el-option label="中国" value="cn" />
                        <el-option label="美洲" value="us" />
                        <el-option label="欧洲" value="eu" />
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="submitForm">确定</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script type="text/ecmascript-6">
import api from '../../../axios/pack'
export default {
    name: '',
    mixins: [],
    components: {},
    props: {},
    data() {
        return {
            search: {
                page: 1,
                limit: 20,
                name: '',
                model: ''
            },
            list: [],
            total: 0,
            Packcode: '',
            packmodellist: [],
            ruleList: [],
            dialogVisible: false,
            form: {
                rule_code: '',
                region: ''
            },
            rules: {
                rule_code: [
                    { required: true, message: '请选择规则', trigger: 'change' }
                ],
                region: [
                    { required: true, message: '请选择区域', trigger: 'change' }
                ]
            }
        }
    },
    computed: {},
    watch: {},
    methods: {
        // 获取规则列表
        getContentManageRuleList() {
            this.api.ContentManageRuleList({ page: 1, limit: 500 }).then(res => {
                if (res.data.code == 200) {
                    this.ruleList = res.data.data.list
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        Search() {
            this.search.page = 1
            this.distriList()
        },
        handleCurrentChange(val) {
            this.search.page = val
            this.distriList()
        },
        distriList() {
            api.RulePackDistriList({
                set_meal_code: this.Packcode
            }).then(res => {
                if (res.data.code == 200) {
                    this.list = res.data.data
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        showAddDialog() {
            this.dialogVisible = true
            this.form = {
                rule_code: '',
                region: ''
            }
        },
        submitForm() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    api.RulePackDistriCreate({
                        rule_code: this.form.rule_code,
                        set_meal_code: this.Packcode,
                        region: this.form.region
                    }).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success('新增成功')
                            this.dialogVisible = false
                            this.distriList()
                            return
                        }
                        this.$message.error('新增失败' + res.data.msg)
                    })
                } else {
                    return false
                }
            })
        },
        delRule(item) {
            this.$confirm('你确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                api.RulePackDistriDelete({
                    set_meal_code: this.Packcode,
                    rule_code: item.rule_code,
                    region: item.region
                }).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('删除成功')
                        this.distriList()
                        return
                    }
                    this.$message.error('删除失败' + res.data.msg)
                })
            }).catch((e) => {
                console.log(e)
                this.$message.info('已取消')
            })
        },
        goback() {
            this.$router.push('/iot/pack')
        }
    },
    filters: {},
    mounted() {

    },
    created() {
        this.Packcode = this.$route.params.code
        this.Search()
        this.getContentManageRuleList()
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
</style>
